import { analyticsEvent } from "./analytics-controller";

angular
  .module("informaCollectionApp", ["ngSanitize"])
  .filter('limitAuthors', function($sce) {
    return function (input, limit) {
        if (!input) return '';
        var matches = input.match(/<a [^>]+>.*?<\/a>/g);
        if (!matches) return input;
        var limited = matches.slice(0, limit).join(', ');
        if (matches.length > limit) {
            limited += ' and ' + (matches.length - limit) + ' more';
        }
        return $sce.trustAsHtml(limited);
    };
  })
  .controller("collectionController", function ($scope, $window, $http) {
    angular.element(document).ready(function () {
      $scope.Init();
    });

    angular.element(document).bind("scroll", function () {
      $scope.timelineContainer = $(".timeline-container");
      $scope.years_menu = document.querySelector("#timeline_tabs");
      $scope.$yearsMenu = $($scope.years_menu);
      $scope.dataContent = document.querySelector("#timeline-content");
      $scope.stickyTop = $scope.getOffsetTop($scope.years_menu);
      $scope.menuList = $scope.years_menu.querySelectorAll("li");
      $scope.dataTabContent = document.querySelector(".timeline-content");
      $scope.stickyBottom = $scope.getOffsetTop($scope.dataTabContent);
      $scope.menuScroll;
      $scope.dataTabSections = document.querySelectorAll(
        ".timeline-content .timeline-content-tile"
      );
      $scope.stickyOnScroll();
    });

    $scope.InitialCollection = {};
    $http
      .get(
        "/api/informasearch/collectionresults?pId=" +
        $("#collection-listing").data("settingsid")
      )
      .then(function (response) {
        $scope.CollectionData = response.data;
        $scope.InitialCollection = response.data;
        var selectedYears = [];
        $.each($scope.InitialCollection.facets, function (i, element) {
          if (element.id == "1") {
            selectedYears.push(element.label);
          }
        });
        if (selectedYears.length > 0) {
          var filteredArray = $scope.InitialCollection.results.filter((itm) => selectedYears.includes(itm.year) );
          var filterData = {
            results: filteredArray,
            facets: $scope.InitialCollection.facets,
          };
          $scope.CollectionData = filterData;
        }
        if (response.data.results.length > 0) {
          // call all data dependant code
          // sets date from first result
          $scope.populateTitlePubDate(
            response.data.results[0].assetFamilyList
              ? response.data.results[0].assetFamilyList[0].publishDate
              : undefined
          );
        } else {
          $("#collection-listing").hide();
        }
      });

    $scope.UpdateFilter = function () {
      var selectedYear = [];
      $("[name=collection-filter-year]:checked").each(function () {
        selectedYear.push($(this).val());
      });
      if (selectedYear.length > 0) {
        $scope.timelineContainer.show();
        var filteredArray = $scope.InitialCollection.results.filter(function (
          itm
        ) {
          return selectedYear.includes(itm.year);
        });
        var filterData = {
          results: filteredArray,
          facets: $scope.InitialCollection.facets,
        };
        $scope.CollectionData = filterData;
        $scope.Init();
      } else {
        $scope.timelineContainer.hide();
      }
    };
    // sticky scroll
    $scope.getOffsetTop = function (element) {
      var offsetTop = 0;
      while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }
      return offsetTop;
    };

    $scope.Init = function () {
      $scope.timelineContainer = $(".timeline-container");
      $scope.years_menu = document.querySelector("#timeline_tabs");
      $scope.$yearsMenu = $($scope.years_menu);
      $scope.dataContent = document.querySelector("#timeline-content");
      $scope.stickyTop = $scope.getOffsetTop($scope.years_menu);
      $scope.menuList = $scope.years_menu.querySelectorAll("li");
      $scope.dataTabContent = document.querySelector(".timeline-content");
      $scope.stickyBottom = $scope.getOffsetTop($scope.dataTabContent);
      $scope.dataTabSections = document.querySelectorAll(".timeline-content .timeline-content-tile");
      if ($scope.dataTabContent) {
        $scope.dataTabs = $scope.dataTabContent.querySelectorAll(
          ".timeline-content-tile"
        );
      }
      for (var menu of $scope.menuList) {
        menu.addEventListener("click", function () {
          for (var menu of $scope.menuList) {
            menu.classList.remove("active");
          }
          this.classList.add("active");
        });
      }
      $scope.stickyOnScroll();
	
      window.indexBookmarks();
      window.findTooltips();

      $scope.anchorClick = function ($event) {
        var dataInfo = $event.currentTarget.getAttribute("data-info");
        if (dataInfo) {
          analyticsEvent(
            $.extend($window.analytics_data, JSON.parse(dataInfo))
          );
        }
        $event.stopImmediatePropagation();
      };

      // ensure there is a small spacer at the bottom so the last tab can activate
      $scope.addTimelineBottomSpacer = function () {
        if (!$scope.dataTabContent) return;
        var spacer = $scope.dataTabContent.querySelector('.timeline-bottom-spacer');
        if (!spacer) {
          spacer = document.createElement('div');
          spacer.className = 'timeline-bottom-spacer';
          spacer.style.width = '100%';
          spacer.style.pointerEvents = 'none';
          $scope.dataTabContent.appendChild(spacer);
        }
        var compact = Math.floor(window.innerHeight * 0.30);
        var spacerHeight = Math.max(200, Math.min(200, compact));
        spacer.style.height = spacerHeight + 'px';
      };
      $scope.addTimelineBottomSpacer();
      if (!$scope._spacerResizeBound) {
        $scope._spacerResizeBound = true;
        window.addEventListener('resize', function () {
          $scope.addTimelineBottomSpacer();
        });
      }
    };
    $scope.populateTitlePubDate = function (publishDate) {
      var $pubDateEl = $("#collection-publish-date"),
        pubDateLabel = $pubDateEl.data("text");

      if (publishDate) {
        $pubDateEl.text(pubDateLabel + " " + publishDate).addClass("populated");
      } else {
        $pubDateEl.prev(".inf-backslash").remove();
        $pubDateEl.remove();
      }
    };
    $scope.getHeaderHeight = function () {
      var headerHeight = 0;
      var margin = 0;
      if ($(window).width() <= 480) {
        if (!$scope.mobileHeaderHeight) {
          $scope.mobileHeaderHeight = $(".header__wrapper").height();
        }
        headerHeight = $scope.mobileHeaderHeight;
        margin = 10;
      } else {
        if (!$scope.desktopHeaderHeight) {
          $scope.desktopHeaderHeight = $(".header__wrapper").height();
        }
        headerHeight = $scope.desktopHeaderHeight;
        margin = 20;
      }
      return headerHeight + margin;
    };
    // set active item
    $scope.setActiveItemByScrollY = function () {
      var scrolledY = window.scrollY + $scope.getHeaderHeight();
      var isActiveSet = false;
      for (var i = 0; i < $scope.dataTabSections.length; i++) {
        if (scrolledY >= $scope.getOffsetTop($scope.dataTabSections[i])) {
          for (var menu of $scope.menuList) {
            menu.classList.remove("active");
          }
          $scope.menuList[i].classList.add("active");
          isActiveSet = true;
        }
      }
      if (!isActiveSet && $scope.menuList.length > 0) {
        $scope.menuList[0].classList.add("active");
        isActiveSet = true;
      }
    };
    // center the active item in the viewport
    $scope.centerOnActiveItem = function () {
      var $menuItems = $scope.$yearsMenu.children();
      var $firstMenuItem = $menuItems.eq(0);
      var menuItemHeight = $firstMenuItem.height() + parseInt($firstMenuItem.css("margin-bottom"));
      var $activeLi = $menuItems.filter(".active");
      var activeLiInd = $menuItems.index($activeLi);
      var activeLiYPos = menuItemHeight * activeLiInd;
      $scope.$yearsMenu.removeClass("sticky");
      $scope.$yearsMenu.addClass("sticky-mid");
      if ($activeLi.length > 0)
        $scope.$yearsMenu.css(
          "margin-top",
          -(activeLiYPos + menuItemHeight / 2)
        );
    };
    $scope.stickyOnScroll = function () {
      var isTimelineTop =
        window.scrollY >
        $scope.timelineContainer.offset().top - $scope.getHeaderHeight();
      var isMenuTallerThanViewport = false;

      $scope.$yearsMenu.removeClass("sticky anchor-bottom sticky-mid");
      $scope.$yearsMenu.css("margin-top", "");
      // reproduces sticky behavior for timeline menu
      // TODO: replace with CSS sticky (atm not working on mobile)
      if (isTimelineTop) {
        $scope.$yearsMenu.addClass("sticky");
        isMenuTallerThanViewport =
          $scope.years_menu.clientHeight >
          window.outerHeight - $scope.getHeaderHeight();
        $scope.dataContent.style.marginLeft =
          $("#timeline_tabs").width() + "px";
      } else {
        $scope.$yearsMenu.removeClass("sticky");
        $scope.dataContent.style.marginLeft = 0 + "px";
      }
      // anchors to bottom if viewport reaches the bottom of content
      // TODO: remove if CSS sticky implemented
      if ($scope.dataTabContent.clientHeight > window.outerHeight) {
        var bottomAbs = window.pageYOffset + window.outerHeight;
        var contentBottom =
          $scope.stickyBottom + $scope.dataTabContent.clientHeight;
        var yearsMenuBottom =
          $scope.$yearsMenu.offset().top + $scope.$yearsMenu.offset().height;
        if (
          bottomAbs > contentBottom + $scope.getHeaderHeight() &&
          yearsMenuBottom > contentBottom
        ) {
          $scope.$yearsMenu.removeClass("sticky");
          $scope.$yearsMenu.addClass("anchor-bottom");
        }
      } else {
        if (bottomAbs > $scope.stickyBottom + window.outerHeight) {
          $scope.$yearsMenu.removeClass("sticky");
          $scope.$yearsMenu.addClass("anchor-bottom");
        }
      }
      // assigns active class to timeline menu if corresponding content item is in viewport
      $scope.setActiveItemByScrollY();
      // if year menu is larger than window height
      // THEN center the active item in the viewport
      if (
        isTimelineTop &&
        isMenuTallerThanViewport &&
        !$scope.$yearsMenu.hasClass("anchor-bottom")
      ) {
        $scope.centerOnActiveItem();
      }
    };
    $scope.$on('ngRepeatFinished', function () {
      // Add any DOM manipulation or logic that depends on finished rendering here
      if (window.indexPopOuts) window.indexPopOuts();
      if (window.indexBookmarks) window.indexBookmarks();
      if (window.autoBookmark) window.autoBookmark();
      if (window.findTooltips) window.findTooltips();
      if (window.renderRevealer) window.renderRevealer();
    });
  }).directive('onFinishRender', function ($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        if (scope.$last === true) {
          $timeout(function () {
            // Emit the custom event specified in the attribute
            scope.$emit(attr.onFinishRender);
          });
        }
      }
    };
  });